// Royal families and marriage alliances (`diplomacy.dynasty`) — English.
// Merged in ./messages.ts.

export const gameDynastyEn = {
  'dynasty.court': 'Royal court',
  'dynasty.princess': 'Princess',
  'dynasty.prince': 'Prince',
  'dynasty.ofHouse': '{rank} of {house}',
  'dynasty.home': 'At court',
  'dynasty.wed': 'Wed to {spouse}',
  'dynasty.travelling': 'On the road to {house}',
  'dynasty.held': 'Held by {captor}',
  'dynasty.dead': 'Dead',
  'dynasty.propose': 'Propose marriage',
  'dynasty.pending': 'Offer sent',
  'dynasty.incoming': 'Offer waiting',
  'dynasty.bonded': 'Bound by marriage',
  'dynasty.atPact': 'At a pact',
  'dynasty.needAlliance': 'Marriage needs a pact or an alliance',
  'dynasty.offerTitle': '{house} offers a marriage',
  'dynasty.offerBody': 'Their {theirs} for your {yours}: a bond that strengthens the alliance.',
  'dynasty.accept': 'Accept',
  'dynasty.decline': 'Decline',
  'dynasty.stage.child': 'Child',
  'dynasty.stage.young': 'Young',
  'dynasty.stage.middle': 'Middle-aged',
  'dynasty.stage.old': 'Elder',
  'dynasty.mourning': 'House {house} mourns its head — the line passes',
} as const;
